const street = [
  { type: ['а/я'], name: 'Абонентский ящик' },
  { type: ['аллея', 'ал'], name: 'Аллея' },
  { type: ['балка'], name: 'Балка' },
  { type: ['берег'], name: 'Берег' },
  { type: ['б-р'], name: 'Бульвар' },
  { type: ['бугор'], name: 'Бугор' },
  { type: ['бухта'], name: 'Бухта' },
  { type: ['вал'], name: 'Вал' },
  { type: ['взв'], name: 'Взвоз' },
  { type: ['въезд'], name: 'Въезд' },
  { type: ['городок'], name: 'Городок' },
  { type: ['гск'], name: 'Гаражно-строит-ный кооператив' },
  { type: ['д'], name: 'Деревня' },
  { type: ['днп'], name: 'Дачное неком-е партнерство' },
  { type: ['дор'], name: 'Дорога' },
  { type: ['ж/д_будка'], name: 'Железнодорожная будка' },
  { type: ['ж/д_казарм'], name: 'Железнодорожная казарма' },
  { type: ['ж/д_оп'], name: 'ж/д останов. (обгонный) пункт' },
  { type: ['ж/д_платф'], name: 'Железнодорожная платформа' },
  { type: ['ж/д_пост'], name: 'Железнодорожный пост' },
  { type: ['ж/д_рзд'], name: 'Железнодорожный разъезд' },
  { type: ['ж/д_ст'], name: 'Железнодорожная станция' },
  { type: ['жт'], name: 'Животноводческая точка' },
  { type: ['заезд', 'ззд'], name: 'Заезд' },
  { type: ['зона'], name: 'Зона' },
  { type: ['казарма'], name: 'Казарма' },
  { type: ['канал'], name: 'Канал' },
  { type: ['кв-л'], name: 'Квартал' },
  { type: ['км'], name: 'Километр' },
  { type: ['кольцо', 'к-цо'], name: 'Кольцо' },
  { type: ['коса'], name: 'Коса' },
  { type: ['линия', 'лн'], name: 'Линия' },
  { type: ['м'], name: 'Местечко' },
  { type: ['маяк'], name: 'Маяк' },
  { type: ['мгстр'], name: 'Магистраль' },
  { type: ['местность'], name: 'Местность' },
  { type: ['мкр'], name: 'Микрорайон' },
  { type: ['мост'], name: 'Мост' },
  { type: ['н/п'], name: 'Некоммерческое партнерство' },
  { type: ['наб'], name: 'Набережная' },
  { type: ['нп'], name: 'Населенный пункт' },
  { type: ['остров'], name: 'Остров' },
  { type: ['п'], name: 'Поселок' },
  { type: ['п/о'], name: 'Почтовое отделение' },
  { type: ['п/р'], name: 'Планировочный район' },
  { type: ['п/ст'], name: 'Поселок и(при) станция(и)' },
  { type: ['парк'], name: 'Парк' },
  { type: ['пер'], name: 'Переулок' },
  { type: ['переезд', 'пер-д'], name: 'Переезд' },
  { type: ['пл'], name: 'Площадь' },
  { type: ['платф'], name: 'Платформа' },
  { type: ['пл-ка'], name: 'Площадка' },
  { type: ['полустанок'], name: 'Полустанок' },
  { type: ['пр-д', 'проезд'], name: 'Проезд' },
  { type: ['пр-к', 'просек'], name: 'Просек' },
  { type: ['пр-ка', 'просека'], name: 'Просека' },
  { type: ['пр-кт'], name: 'Проспект' },
  { type: ['пр-лок', 'проселок'], name: 'Проселок' },
  { type: ['промзона'], name: 'Промзона' },
  { type: ['проток'], name: 'Проток' },
  { type: ['проулок', 'проул'], name: 'Проулок' },
  { type: ['рзд'], name: 'Разъезд' },
  { type: ['ряд'], name: 'Ряд(ы)' },
  { type: ['ряды'], name: 'Ряды' },
  { type: ['с'], name: 'Село' },
  { type: ['сад'], name: 'Сад' },
  { type: ['сзд'], name: 'Съезд' },
  { type: ['сквер', 'с-р'], name: 'Сквер' },
  { type: ['сл'], name: 'Слобода' },
  { type: ['снт'], name: 'Садовое неком-е товарищество' },
  { type: ['спуск', 'с-к'], name: 'Спуск' },
  { type: ['ст'], name: 'Станция' },
  { type: ['стр'], name: 'Строение' },
  { type: ['тер'], name: 'Территория' },
  { type: ['тоннель'], name: 'Тоннель' },
  { type: ['тракт'], name: 'Тракт' },
  { type: ['туп'], name: 'Тупик' },
  { type: ['ул'], name: 'Улица' },
  { type: ['уч-к'], name: 'Участок' },
  { type: ['ф/х'], name: 'Фермерское хозяйство' },
  { type: ['ферма'], name: 'Ферма' },
  { type: ['х'], name: 'Хутор' },
  { type: ['ш'], name: 'Шоссе' },
];
const apartment = [
  { type: ['бокс'], name: 'Бокс' },
  { type: ['кв'], name: 'Квартира' },
  { type: ['пом'], name: 'Помещение' },
]

export const dictionaryAddressTypes = {
  district: [
    // уровень 3
    { type: ['АО'], name: 'Автономный округ' },
    { type: ['вн тер'], name: 'Внутригородская территория' },
    { type: ['г о'], name: 'Городской округ' },
    { type: ['м р-н'], name: 'Муниципальный район' },
    { type: ['пос', 'п'], name: 'Поселение' },
    { type: ['р-н'], name: 'Район' },
    { type: ['тер'], name: 'Территория' },
    { type: ['у'], name: 'Улус' },
    // уровень 35
    { type: ['вн р-н'], name: 'Внутригородской район' },
    { type: ['г п'], name: 'Городское поселение' },
    { type: ['с/п'], name: 'Сельское поселение' },
    { type: ['с/с'], name: 'Сельсовет' },
  ],
  city: [
    { type: ['волость'], name: 'Волость' },
    { type: ['г'], name: 'Город' },
    { type: ['дп'], name: 'Дачный посёлок' },
    { type: ['кп'], name: 'Курортный посёлок' },
    { type: ['массив'], name: 'Массив' },
    { type: ['п'], name: 'Посёлок' },
    { type: ['п/о'], name: 'Почтовое отделение' },
    { type: ['пгт'], name: 'Посёлок городского типа' },
    { type: ['рп'], name: 'Рабочий поселок' },
    { type: ['с/а'], name: 'Сельская администрация' },
    { type: ['с/мо'], name: 'Сельское муниципальное образование' },
    { type: ['с/о'], name: 'Сельский округ' },
    { type: ['с/п'], name: 'Сельское поселение' },
    { type: ['с/с'], name: 'Сельсовет' },
    { type: ['тер'], name: 'Территория' },
  ],
  locality: [
    { type: ['аал'], name: 'Аал' },
    { type: ['а/я'], name: 'Абонентский ящик' },
    { type: ['автодорога'], name: 'Автодорога' },
    { type: ['ал'], name: 'Аллея' },
    { type: ['арбан'], name: 'Арбан' },
    { type: ['аул'], name: 'Аул' },
    { type: ['балка'], name: 'Балка' },
    { type: ['б-г'], name: 'Берег' },
    { type: ['б-р'], name: 'Бульвар' },
    { type: ['вал'], name: 'Вал' },
    { type: ['волость'], name: 'Волость' },
    { type: ['высел'], name: 'Выселки(ок)' },
    { type: ['взд'], name: 'Въезд' },
    { type: ['гск'], name: 'Гаражно-строительный кооп.' },
    { type: ['г'], name: 'Город' },
    { type: ['городок', 'г-к'], name: 'Городок' },
    { type: ['гп'], name: 'городской поселок' },
    { type: ['д'], name: 'Деревня' },
    { type: ['днп'], name: 'Дачное неком-е партнерство' },
    { type: ['дп'], name: 'Дачный поселок' },
    { type: ['дор'], name: 'Дорога' },
    { type: ['ж/д_будка', 'ж/д б-ка'], name: 'Железнодорожная будка' },
    { type: ['ж/д_казарм', 'ж/д к-ма'], name: 'Железнодорожная казарма' },
    { type: ['ж/д_оп'], name: 'ж/д останов. (обгонный) пункт' },
    { type: ['ж/д_платф', 'ж/д пл-ма'], name: 'Железнодорожная платформа' },
    { type: ['ж/д_пост'], name: 'Железнодорожный пост' },
    { type: ['ж/д_рзд', 'ж/д рзд'], name: 'Железнодорожный разъезд' },
    { type: ['ж/д_ст', 'ж/д ст'], name: 'Железнодорожная станция' },
    { type: ['жилзона'], name: 'Жилая зона' },
    { type: ['жилрайон', 'ж/р'], name: 'Жилой район' },
    { type: ['ззд'], name: 'Заезд' },
    { type: ['заимка'], name: 'Заимка' },
    { type: ['зона'], name: 'Зона (массив)' },
    { type: ['казарма'], name: 'Казарма' },
    { type: ['кв-л'], name: 'Квартал' },
    { type: ['кордон'], name: 'Кордон' },
    { type: ['км'], name: 'Километр' },
    { type: ['коса'], name: 'Коса' },
    { type: ['к-цо'], name: 'Кольцо' },
    { type: ['кп'], name: 'Курортный поселок' },
    { type: ['лпх'], name: 'Леспромхоз' },
    { type: ['лн'], name: 'Линия' },
    { type: ['м', 'м-ко'], name: 'Местечко' },
    { type: ['массив'], name: 'Массив' },
    { type: ['месторожд'], name: 'Месторождение' },
    { type: ['местность'], name: 'Местность' },
    { type: ['мкр'], name: 'Микрорайон' },
    { type: ['нп'], name: 'Населенный пункт' },
    { type: ['н/п'], name: 'Некоммерческое партнерство' },
    { type: ['наб'], name: 'Набережная' },
    { type: ['остров', 'ост-в'], name: 'Остров' },
    { type: ['парк'], name: 'Парк' },
    { type: ['пер'], name: 'Переулок' },
    { type: ['пер-д'], name: 'Переезд' },
    { type: ['п'], name: 'Поселок' },
    { type: ['п/о'], name: 'Почтовое отделение' },
    { type: ['п/р'], name: 'Планировочный район' },
    { type: ['п/ст'], name: 'Поселок и(при) станция(и)' },
    { type: ['пгт'], name: 'Поселок городского типа' },
    { type: ['погост'], name: 'Погост' },
    { type: ['починок', 'п-к'], name: 'Починок' },
    { type: ['пл'], name: 'Площадь' },
    { type: ['платф'], name: 'Платформа' },
    { type: ['пл-ка'], name: 'Площадка' },
    { type: ['порт'], name: 'Порт' },
    { type: ['пр-д'], name: 'Проезд' },
    { type: ['пр-к'], name: 'Просек' },
    { type: ['пр-ка'], name: 'Просека' },
    { type: ['пр-кт'], name: 'Проспект' },
    { type: ['пр-лок'], name: 'Проселок' },
    { type: ['промзона'], name: 'Промышленная зона' },
    { type: ['п/р'], name: 'Промышленный район' },
    { type: ['проул'], name: 'Проулок' },
    { type: ['рзд'], name: 'Разъезд' },
    { type: ['рп'], name: 'Рабочий поселок' },
    { type: ['р-н'], name: 'Район' },
    { type: ['с'], name: 'Село' },
    { type: ['сад'], name: 'Сад' },
    { type: ['с-к'], name: 'Спуск' },
    { type: ['сквер', 'с-р'], name: 'Сквер' },
    { type: ['сл'], name: 'Слобода' },
    { type: ['снт'], name: 'Садовое неком-е товарищество' },
    { type: ['ст'], name: 'Станция' },
    { type: ['ст-ца'], name: 'Станица' },
    { type: ['стр'], name: 'Строение' },
    { type: ['тер'], name: 'Территория' },
    { type: ['тер ГСК'], name: 'Территория ГСК' },
    { type: ['тер ДНО'], name: 'Территория ДНО' },
    { type: ['тер ДНП'], name: 'Территория ДНП' },
    { type: ['тер ДНТ'], name: 'Территория ДНТ' },
    { type: ['тер ДПК'], name: 'Территория ДПК' },
    { type: ['тер ОНО'], name: 'Территория ОНО' },
    { type: ['тер ОНП'], name: 'Территория ОНП' },
    { type: ['тер ОНТ'], name: 'Территория ОНТ' },
    { type: ['тер ОПК'], name: 'Территория ОПК' },
    { type: ['тер СНО'], name: 'Территория СНО' },
    { type: ['тер СНП'], name: 'Территория СНП' },
    { type: ['тер СНТ'], name: 'Территория СНТ' },
    { type: ['тер СПК'], name: 'Территория СПК' },
    { type: ['тер ТСН'], name: 'Территория ТСН' },
    { type: ['тер ф х'], name: 'Территория ФХ' },
    { type: ['тракт'], name: 'Тракт' },
    { type: ['туп'], name: 'Тупик' },
    { type: ['ул'], name: 'Улица' },
    { type: ['ус'], name: 'Усадьба' },
    { type: ['у'], name: 'Улус' },
    { type: ['ф/х'], name: 'Фермерское хозяйство' },
    { type: ['х'], name: 'Хутор' },
    { type: ['ш'], name: 'Шоссе' },
    { type: ['ю'], name: 'Юрты' },
  ],
  street,
  streetWithSteed: [...street, { type: ['з/у'], name: 'Земельный участок' }],
  apartment,
  apartmentWithRoom: [
    { type: ['ком'], name: 'Комната' },
  ],
  building: [
    { type: ['стр'], name: 'Cтроение' },
    { type: ['к'], name: 'Корпус' },
  ],
};

/*
 * Маппинг корпус/строение из Есия в Дадату
 * из Есия нам приходит другой формат:
 * flat - квартира, building - корпус, frame - строение
 */
export function mapEsiaIntoDadata(data: any) {
  const newData: any = {};
  if (data.building && data.frame) {
    // имеются корпус и строение
    newData.block = `${data.building} стр ${data.frame}`;
    newData.block_type = 'к';
    newData.block_type_full = 'корпус';
  }

  if (data.building && !data.frame) {
    // только корпус
    newData.block = data.building;
    newData.block_type = 'к';
    newData.block_type_full = 'корпус';
  }

  if (data.frame && !data.building) {
    // только строение
    newData.block = data.frame;
    newData.block_type = 'стр';
    newData.block_type_full = 'строение';
  }
  return newData;
}

/*
 * Маппинг корпус/строение из Дадаты в Нашу Схему
 * buildingType - строение значение
 * buildingName - строение тип
 * block - корпус
 */
export function mapDadataIntoSchema(data: any) {
  const newData: any = {};
  const isBlockBuilding: boolean = data?.block && data.block.includes(' стр ');

  if (isBlockBuilding) {
    // имеются корпус и строение
    const arr = data.block.split(' стр ');
    newData.block = arr[0];
    newData.buildingName = arr[1];
    newData.buildingType = 'стр';
  }

  if (!isBlockBuilding && data.block_type_full === 'строение') {
    // только строение
    newData.buildingName = data.block;
    newData.buildingType = data.block_type;
  }

  if (!isBlockBuilding && data.block_type_full === 'корпус') {
    // только корпус
    newData.block = data.block;
  }

  return newData;
}
